import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    getPresignedUrl: string
}

interface Variables {
    fileId: string,
}

export const GET_PRESIGNED_URL: TypedDocumentNode<Result, Variables> = gql`
    query GetPresignedUrl($fileId: Int!) {
        getPresignedUrl(fileId: $fileId)
    }       
`
